// extracted by mini-css-extract-plugin
export default {"container":"TablaMaterias_container__GsUs6","link":"TablaMaterias_link__ltr5P","marginBottom":"TablaMaterias_marginBottom__xHXG8"};